<template>
    <div class="service-level-detail-modal modal-card">
        <header class="modal-card-head">
            <div class="title modal-card-title">{{ row.title }}
                <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                    <o-icon pack="fa" icon="gear" size="is-small"/>
                </a>
            </div>

        </header>
        <section class="modal-card-body">
            <div class="columns filters-container">
                <div class="column is-6-tablet">
                    <o-field>
                        <o-input
                            type="search"
                            v-model="filters.projectName"
                            placeholder="Project Name / Number"
                            icon="search"
                        />
                    </o-field>
                </div>
                <div class="column is-6-tablet">
                    <div class="field">
                        <multicomplete v-model="serviceUsers" type="user" placeholder="Project Manager" />
                    </div>
                </div>
                <div class="column is-6-tablet">
                    <o-field>
                        <autocomplete-select
                                v-model="filters.company_id"
                                :custom="{placeholder: 'Company'}"
                                type="company"
                                @input="fetchPaginatedData(true)"
                        />
                    </o-field>
                </div>
                <div class="column is-6-tablet">
                    <o-field>
                        <o-select
                                v-model="filters.borough"
                                :expanded="true"
                                placeholder="Borough"
                                @input="fetchPaginatedData(true)"
                        >
                            <option
                                    v-for="(b, i) in boroughs"
                                    :value="b.id"
                                    :key="i"
                            >
                                {{ b.name }}
                            </option>
                        </o-select>
                    </o-field>
                </div>
            </div>
            <div class="columns">
                <div class="column"></div>
                <div class="column is-2 action-box">
                    <div class="field">
                        <p v-if="isResetFiltersButtonVisible" class="control">
                            <a @click.prevent="resetFilters" class="button is-info is-pulled-right"><span>Reset filters</span></a>
                        </p>
                    </div>
                </div>
            </div>
            <br>
            <o-table
                    class="service-level-detail is-responsive is-responsive-desktop"

                    v-if="isTableVisible"
                    :data="paginatedData"

                    :bordered="table.bordered"
                    :striped="table.striped"
                    :narrowed="table.narrowed"
                    :checkable="false"
                    :mobile-cards="table.mobileCards"
                    :paginated="table.paginated"
                    :pagination-simple="table.paginationSimple"
                    :per-page="table.perPage"
                    :default-sort="table.defaultSort"

                    :selected.sync="selected"
                    :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"

                    :loading="loading"
                    :total="total"
                    backend-sorting
                    backend-pagination
                    @page-change="onPageChange"
                    @sort="onSort"
            >
                <template slot-scope="props">
                    <template v-for="col in tableColumns" :key="col.field">
                        <o-table-column
                                :field="col.field"
                                :label="col.field === 'actions' ? '' : col.label"

                                :sortable="col.sortable"
                        >
                            <span v-if="col.field === 'borough'">{{ boroughNameById(props.row[col.field]) | valueOrDefault('-') }}</span>
                            <router-link v-else-if="col.field === 'project_id'" :to="{ name: 'projects.show.services', params: { slug: props.row.project_id } }">
                                {{ props.row.project_id }}
                            </router-link>
                            <router-link v-else-if="col.field === 'project_name'" :to="{ name: 'projects.show.services', params: { slug: props.row.project_id } }">
                                {{ props.row.project_name | valueOrDefault('-') }}
                            </router-link>
                            <span v-else-if="col.field === 'amount'">
                                {{ props.row.amount | currency }}
                            </span>
                            <span v-else-if="col.field === 'timelog'">
                                {{ props.row[col.field] | valueOrDefault('-') | toFixed(2) }}
                            </span>
                            <span v-else-if="col.field === 'days'">
                                {{ props.row.days }}
                            </span>
                            <span v-else>
                                {{ props.row[col.field] | valueOrDefault('-') }}
                            </span>
                        </o-table-column>
                    </template>
                </template>
                <template slot="footer">
                    <template v-for="(col, idx) in tableColumns">
                        <th v-if="col.field === 'amount'" label="Amount" :key="idx">
                            {{ totalsColumns.amount | currency }}
                        </th>
                        <th v-else-if="col.field === 'days'" label="Days">
                            {{ totalsColumns.daysAvg }}
                        </th>
                        <th v-else-if="idx === 0" >Totals / Avg</th>
                    </template>
                </template>
                <div slot="empty" class="has-text-centered">
                    This table is empty!
                </div>
            </o-table>
           <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
                <table-settings-modal :slug="tableName"/>
            </o-modal>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
        </footer>
    </div>
</template>

<script>
    import Datepicker from './../../../components/Datepicker'
    import Table from './../../../mixins/Table'
    import { mapGetters } from 'vuex'

    export default {
        mixins: [Table],

        components: {
            Datepicker,
        },

        computed: {
            ...mapGetters([
                'workTypeNamesByIds',
                'boroughNameById',
                'boroughs',
                'teamNameById',
                'teams'
            ]),
            totalsColumns() {
                const data = this.paginatedData,
                totalsColumns = { amount: 0, count: 0, days: 0, daysAvg: 0, },
                perPage = this.table.perPage || 0,
                start = 0,
                end = perPage
                for (let idx = start; idx < end && idx < data.length; idx++) {
                    totalsColumns.count++
                    const days = parseInt(data[idx].days)
                    totalsColumns.amount += parseInt(data[idx].amount) || 0
                    totalsColumns.days += isNaN(days) ? 0 : days
                }
                totalsColumns.daysAvg = Number(totalsColumns.days / (totalsColumns.count || 1)).toFixed(2)
                return totalsColumns
            },
       },

        data() {
            return {
                contacts: [],
                exclude_services: [],
                filters: {
                    allDates: false,
                    contacts: [],
                    converted_from: null,
                    converted_to: null,
                    exclude_services: [],
                    from: null,
                    projects: [],
                    table: {
                        defaultSort: ['days', 'desc'],
                        perPage: 10,
                        perPageOptions: [5, 10, 15, 25, 50],
                    },
                    team_id: null,
                    to: null,
                    services: [],
                    serviceUsers: [],
                    users: [],
                    viewAll: false,
                },
                isTableSettingsModalActive: false,
                items: [],
                projects: [],
                services: [],
                serviceUsers: [],
                table: {
                    paginated: true,
                },
                tableName: 'service-level-details',
                urlFilter: { enabled: false },
                users: [],
            }
        },

        methods: {
            fetchData(filters) {
                const services = [this.row.service_id]
                const params = { ...this.filtersProp, ...filters, services }
                return axios.get(`/api/reports/service-level-details-report`, { params })
                    .then(res => {
                        this.items = res.data.data
                        return res
                    })
            },

            itemsByIds() {
                return this.items
            }
        },

        mounted() {
            this.fetchPaginatedData()
        },

        props: {
            filtersProp: {
                type: Object,
            },
            row: {
                type: Object,
            },
        },

        watch: {
            filters: {
                deep: true,
                handler() {
                    this.fetchPaginatedData()
                }
            },
            viewAll: {
                immediate: true,
                handler() {
                    this.table.paginated = ! this.viewAll

                    this.fetchPaginatedData()
                }
            },

            'filters.contacts'(v) { if (v.length === 0 && this.contacts.length) this.contacts = [] },
            'filters.exclude_services'(v) { if (v.length === 0 && this.exclude_services.length) this.exclude_services = [] },
            'filters.projects'(v) { if (v.length === 0 && this.projects.length) this.projects = [] },
            'filters.services'(v) { if (v.length === 0 && this.services.length) this.services = [] },
            'filters.serviceUsers'(v) { if (v.length === 0 && this.serviceUsers.length) this.serviceUsers = [] },
            'filters.users'(v) { if (v.length === 0 && this.users.length) this.users = [] },

            contacts() { this.filters.contacts = _.map(this.contacts, 'id') },
            exclude_services() { this.filters.exclude_services = _.map(this.exclude_services, 'id') },
            projects() { this.filters.projects = _.map(this.projects, 'id') },
            services() { this.filters.services = _.map(this.services, 'id') },
            serviceUsers() { this.filters.serviceUsers = _.map(this.serviceUsers, 'id') },
            users() { this.filters.users = _.map(this.users, 'id') },
        },
    }
</script>
<style>
.service-level-detail-modal {
  width: 100%; }
  .service-level-detail-modal .filters-container {
    align-items: center;
    flex-wrap: wrap; }

</style>
